// // src/pages/OnboardingComplete.jsx
// import React, { useEffect } from 'react';
// import { useSearchParams } from 'react-router-dom';

// const OnboardingComplete = () => {

//   const [searchParams] = useSearchParams();
//   const cleanerId = searchParams.get("cleanerId");

//   useEffect(() => {
//     const deepLink = `freshsweeper://onboarding-complete${cleanerId ? `?cleanerId=${cleanerId}` : ''}`;
//     window.location.href = deepLink;
//   }, []);

//   const deepLink = `freshsweeper://onboarding-complete${cleanerId ? `?cleanerId=${cleanerId}` : ''}`;

//   return (
//     <div style={styles.container}>
//       <h2>Onboarding Complete!</h2>
//       <p>Redirecting you back to the app...</p>
//       <p>If not redirected, <a href={deepLink}>click here</a></p>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: '40px',
//     textAlign: 'center',
//     fontFamily: 'sans-serif',
//   },
// };

// export default OnboardingComplete;


import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const OnboardingComplete = () => {
  const [searchParams] = useSearchParams();
  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const cleanerId = searchParams.get("cleanerId");

  // Create the deep link URL
  const deepLink = `freshsweeper://onboarding-complete${cleanerId ? `?cleanerId=${cleanerId}` : ''}`;

  useEffect(() => {
    // Try to redirect to the app
    const redirectToApp = () => {
      console.log('🔗 Redirecting to app:', deepLink);
      window.location.href = deepLink;
      setRedirectAttempted(true);
    };

    // Redirect immediately
    redirectToApp();

    // If still on web after 2 seconds, show fallback options
    const fallbackTimer = setTimeout(() => {
      if (document.visibilityState === 'visible') {
        console.log('📱 App not installed or redirect failed');
      }
    }, 80000);

    return () => clearTimeout(fallbackTimer);
  }, [deepLink]);

  return (
    <div style={styles.container}>
      <h2>🎉 Onboarding Complete!</h2>
      
      {cleanerId && (
        <div style={styles.infoBox}>
          <p><strong>Cleaner ID:</strong> {cleanerId}</p>
        </div>
      )}

      <p>Redirecting you back to the FreshSweeper app...</p>
      
      {redirectAttempted && (
        <div style={styles.fallback}>
          <p>If you weren't redirected automatically:</p>
          <div style={styles.buttonContainer}>
            <a href={deepLink} style={styles.primaryButton}>
              Open in FreshSweeper App
            </a>
            <a href="/" style={styles.secondaryButton}>
              Go to Homepage
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '40px 20px',
    textAlign: 'center',
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    maxWidth: '600px',
    margin: '0 auto',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoBox: {
    background: '#f8f9fa',
    padding: '15px',
    borderRadius: '8px',
    margin: '20px 0',
    border: '1px solid #e9ecef',
  },
  fallback: {
    marginTop: '30px',
    padding: '20px',
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
    border: '1px solid #e0e0e0',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    margin: '20px 0',
  },
  primaryButton: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#00BFFF',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '16px',
    transition: 'background-color 0.2s',
  },
  secondaryButton: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#6c757d',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '16px',
    transition: 'background-color 0.2s',
  },
};

export default OnboardingComplete;